import { useResetCrudSelectionOnUnmount } from '@/atoms'

import { DepotForm } from './DepotForm/DepotForm'
import { List } from './List'
import { BulkPreview } from './Preview/Bulk/BulkPreview'
import { SinglePreview } from './Preview/Single/SinglePreview'
import { useDepotsRoot } from './hooks/useDepotsRoot'

export function DepotsRoot() {
  const { editing, depots, selectedDepots, selection } = useDepotsRoot()
  const bulk = selectedDepots.length > 1
  const single = selectedDepots.length === 1

  const depot = selectedDepots[0]

  useResetCrudSelectionOnUnmount('depots')

  return (
    <>
      <List editing={editing} depots={depots} selection={selection} />
      {single && !editing && depot && <SinglePreview depot={depot} />}
      {bulk && <BulkPreview depots={selectedDepots} />}
      {editing && !bulk && <DepotForm depot={depot} />}
    </>
  )
}
